__turbopack_context__.v({
  "details": "ForecastSection-module-scss-module__TtDQgG__details",
  "detailsContainer": "ForecastSection-module-scss-module__TtDQgG__detailsContainer",
  "enabled": "ForecastSection-module-scss-module__TtDQgG__enabled",
  "scrollButton": "ForecastSection-module-scss-module__TtDQgG__scrollButton",
});
